export default __webpack_public_path__ + "static/img_ja-263974cfafbd4f8268c89d2c95c5c731.gif";